import React, { useEffect } from "react";
import { Box } from "@chakra-ui/react";
import { FiMail, FiEye, FiCheckSquare, FiCheckCircle, FiShield } from "react-icons/fi";
import { InfoPage, InfoBody, InfoSectionTitle, NumberedSteps, FaqList } from "../infoShared";

const STEPS = [
  { icon: FiMail, title: "Dostajesz link do głosowania", desc: "Organizator wysyła Ci link na e-mail albo znajdujesz głosowanie otwarte na liście. Konto nie jest potrzebne." },
  { icon: FiEye, title: "Otwierasz głosowanie", desc: "Sprawdzasz pytania, opcje i informacje o organizatorze. Wiesz dokładnie, nad czym głosujesz." },
  { icon: FiCheckSquare, title: "Oddajesz głos", desc: "Wybierasz odpowiedzi i wysyłasz. W zależności od ustawień głosowanie jest tajne albo jawne imienne." },
  { icon: FiCheckCircle, title: "Potwierdzasz e-mailem", desc: "Klikasz link z wiadomości potwierdzającej — to chroni głosowanie przed nadużyciami." },
  { icon: FiShield, title: "Gotowe — Twój głos jest policzony", desc: "Po zakończeniu wynik trafia do protokołu zakotwiczonego na blockchainie, który każdy może zweryfikować." }
];

const FAQS = [
  { q: "Czy potrzebuję konta?", a: "Nie. Do udziału w głosowaniu wystarczy link od organizatora lub zapis do głosowania otwartego." },
  { q: "Czy mój głos jest anonimowy?", a: "Jeśli organizator wybrał głosowanie tajne — tak. Przy głosowaniu jawnym imiennym Twój wybór jest powiązany z Tobą." },
  { q: "Mogę zmienić głos po wysłaniu?", a: "Po potwierdzeniu głos jest finalny. Przed potwierdzeniem e-mailem możesz oddać go ponownie." }
];

export const HowToVoteView: React.FC = () => {
  useEffect(() => {
    document.title = "Jak zagłosować";
  }, []);

  return (
    <InfoPage
      eyebrow="Dla głosujących"
      title="Jak zagłosować"
      subtitle="Oddanie głosu zajmuje chwilę i nie wymaga zakładania konta. Zobacz, jak to wygląda krok po kroku."
    >
      <InfoBody narrow>
        <InfoSectionTitle>Krok po kroku</InfoSectionTitle>
        <NumberedSteps steps={STEPS} />

        <Box mt={{ base: "48px", md: "64px" }}>
          <InfoSectionTitle>Częste pytania</InfoSectionTitle>
          <FaqList items={FAQS} />
        </Box>
      </InfoBody>
    </InfoPage>
  );
};
